"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const provider_components_1 = require("@kyruus/provider-components");
const intl_1 = require("@kyruus/intl");
const styles_1 = require("../LayoutFactory/styles");
const useWindowWidth_1 = __importDefault(require("../../lib/useWindowWidth"));
/**
 * Convert the appointment location object to a format that can be used by the ProviderSidebar component
 *
 * @param {Object} param0 Appointment object
 * @param {Object} param0.location Appointment location object
 * @returns
 */
const selectedLocationAdapter = (_a) => {
    var _b = _a.location, { address } = _b, rest = __rest(_b, ["address"]);
    return (Object.assign(Object.assign({}, rest), address));
};
/**
 * A memoized component for rendering the provider sidebar with appointment information.
 * This component centralizes the sidebar logic used across different layout components.
 */
const MemoizedProviderSidebar = react_1.default.memo(({ provider, appointment, appointmentQuery, showAppointmentId = false, appointmentIdMessage }) => {
    const { aboveMd } = (0, useWindowWidth_1.default)();
    if (!provider) {
        return null;
    }
    return (react_1.default.createElement(provider_components_1.ProviderSidebar, { appointmentQuery: appointmentQuery, selectedLocation: selectedLocationAdapter(appointment), provider: provider, showApptTime: true, showSchedulingHelpBanner: aboveMd }, showAppointmentId && (appointment === null || appointment === void 0 ? void 0 : appointment.appointment_ehr_id) && (react_1.default.createElement(styles_1.StyledAppointmentIdContainer, { id: "appointment-id" },
        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, appointmentIdMessage, { values: {
                appointmentId: appointment === null || appointment === void 0 ? void 0 : appointment.appointment_ehr_id
            } }))))));
}, 
// Custom comparison function to optimize re-renders
(prevProps, nextProps) => {
    var _a, _b, _c, _d;
    // Only re-render when these props change
    return (((_a = prevProps.provider) === null || _a === void 0 ? void 0 : _a.id) === ((_b = nextProps.provider) === null || _b === void 0 ? void 0 : _b.id) &&
        ((_c = prevProps.appointment) === null || _c === void 0 ? void 0 : _c.id) === ((_d = nextProps.appointment) === null || _d === void 0 ? void 0 : _d.id) &&
        prevProps.appointmentQuery === nextProps.appointmentQuery &&
        prevProps.showAppointmentId === nextProps.showAppointmentId &&
        prevProps.appointmentIdMessage === nextProps.appointmentIdMessage);
});
MemoizedProviderSidebar.displayName = 'MemoizedProviderSidebar';
exports.default = MemoizedProviderSidebar;
//# sourceMappingURL=MemoizedProviderSidebar.js.map